import React from "react";
import TabLayout from "../../helpers/TabLayout";
import { useRouteLoaderData } from "react-router-dom";
import LabeledEntry from "../../helpers/LabeledEntry";
import { Stack } from "@mui/material";
import EditableField from "../helpers/EditableField";
import { sessionUpdate } from "../../../api/session";
import EditButtons from "../helpers/EditButtons";
import useEditObject from "../../../hooks/useEditObject";

const ContactTab = () => {
  const loaderData = useRouteLoaderData("profileComponent");
  const userEntity = loaderData.userEntityRes?.data;
  const {
    editObject,
    isEditable,
    startEdit,
    stopEdit,
    editHandler: handleFieldChange,
  } = useEditObject();

  const handleSave = async (event) => {
    event.preventDefault();
    const response = await sessionUpdate({
      ...userEntity,
      ...editObject.current,
    });
    if (response.code === "SUCCESS") {
      loaderData.userEntityRes.data = { ...userEntity, ...editObject.current };
      stopEdit();
    }
  };

  return (
    <TabLayout
      headerLabel={"Contact"}
      skeletonLines={5}
    >
      <Stack
        component="form"
        onSubmit={handleSave}
        method="POST"
        height="100%"
        justifyContent="space-between"
      >
        <Stack spacing={4}>
          <LabeledEntry
            label="Primary Email"
            value={userEntity?.email}
          />
          <EditableField
            label="Phone Number"
            type="text"
            id="phone"
            name="phone"
            initialValue={userEntity?.phone}
            placeholder="XXX-XXX-XXXX"
            required={false}
            isEditable={isEditable}
            onChange={handleFieldChange}
          />
        </Stack>
        <EditButtons
          isEditable={isEditable}
          onUpdateClicked={startEdit}
          onSaveClicked={handleSave}
          onCancelClicked={stopEdit}
        />
      </Stack>
    </TabLayout>
  );
};

export default ContactTab;